import { render, staticRenderFns } from "./WorkPerformed.vue?vue&type=template&id=763edb75&"
import script from "./WorkPerformed.vue?vue&type=script&lang=js&"
export * from "./WorkPerformed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports